export default __webpack_public_path__ + "static/media/Clara 9781408324998.8a001db0.jpg";